module.exports = __webpack_public_path__ + "img/zhongguohaiyou.cc6007e1.png";